export const getCurrentWebSocketEndpoint = (): string => {
    const endpoint = process.env.REACT_APP_WEBSOCKET_ENDPOINT;

    if (!endpoint) {
        console.error("❌ REACT_APP_WEBSOCKET_ENDPOINT is not defined in environment variables");
        throw new Error("WebSocket endpoint is not configured");
    }

    return endpoint;
};
